enum ActionType {
	// Acknowledgement Text Actions.
	LOAD_ACKNOWLEDGEMENT_TEXTS = 'LOAD_ACKNOWLEDGEMENT_TEXTS',
	// Admin Navigation Link Actions.
	LOAD_ADMIN_NAVIGATION_LINKS = 'LOAD_ADMIN_NAVIGATION_LINKS',
	// Allowed Endorsement Date Range Actions.
	LOAD_ALLOWED_ENDORSEMENT_DATE_RANGE = 'LOAD_ALLOWED_ENDORSEMENT_DATE_RANGE',
	// App Common Actions.
	LOAD_POSSIBLE_BUSINESS_TYPES = 'LOAD_POSSIBLE_BUSINESS_TYPES',
	LOAD_POSSIBLE_STATES = 'LOAD_POSSIBLE_STATES',
	LOAD_POSSIBLE_MASTER_PRODUCERS = 'LOAD_POSSIBLE_MASTER_PRODUCERS',
	// App Mode Actions.
	ADD_APP_MODE = 'ADD_APP_MODE',
	REMOVE_APP_MODES = 'REMOVE_APP_MODES',
	// Broad Line Of Business Actions.
	LOAD_POSSIBLE_BROAD_LINES_OF_BUSINESS = 'LOAD_POSSIBLE_BROAD_LINES_OF_BUSINESS',
	// Endorsement Building Actions.
	SELECT_ENDORSEMENT_BUILDING = 'SELECT_ENDORSEMENT_BUILDING',
	UNSELECT_ENDORSEMENT_BUILDING = 'UNSELECT_ENDORSEMENT_BUILDING',
	// Claim Actions
	SET_NEW_CLAIM = 'SET_NEW_CLAIM',
	SET_PREVIOUS_CLAIMS = 'SET_PREVIOUS_CLAIMS',
	LOAD_CLAIM_PERILS = 'LOAD_CLAIM_PERILS',
	LOAD_PREVIOUS_CLAIMS = 'LOAD_PREVIOUS_CLAIMS',
	// Disqualifier Text Actions.
	LOAD_DISQUALIFIER_TEXT = 'LOAD_DISQUALIFIER_TEXT',
	// Eligibility Message Priority Actions
	LOAD_ELIGIBILITY_MESSAGE_PRIORITIES = 'LOAD_ELIGIBILITY_MESSAGE_PRIORITIES',
	SELECT_ELIGIBILITY_MESSAGE_PRIORITY = 'SELECT_ELIGIBILITY_MESSAGE_PRIORITY',
	UNSELECT_ELIGIBILITY_MESSAGE_PRIORITY = 'UNSELECT_ELIGIBILITY_MESSAGE_PRIORITY',
	// Endorsement Actions.
	LOAD_ENDORSEMENT = 'LOAD_ENDORSEMENT',
	LOAD_ENDORSEMENT_POSSIBLE_PERILS = 'LOAD_ENDORSEMENT_POSSIBLE_PERILS',
	// Endorsement Eligibility Status Actions.
	LOAD_ENDORSEMENT_ELIGIBILITY_STATUS = 'LOAD_ENDORSEMENT_ELIGIBILITY_STATUS',
	// Endorsement Mortgagee Actions.
	SELECT_ENDORSEMENT_MORTGAGEE = 'SELECT_ENDORSEMENT_MORTGAGEE',
	UNSELECT_ENDORSEMENT_MORTGAGEE = 'UNSELECT_ENDORSEMENT_MORTGAGEE',
	// Main Navigation Link Actions.
	LOAD_MAIN_NAVIGATION_LINKS = 'LOAD_MAIN_NAVIGATION_LINKS',
	// Minimum Cost Per Square Foot Actions
	LOAD_MINIMUM_COSTS_PER_SQUARE_FOOT = 'LOAD_MINIMUM_COSTS_PER_SQUARE_FOOT',
	SELECT_MINIMUM_COST_PER_SQUARE_FOOT = 'SELECT_MINIMUM_COST_PER_SQUARE_FOOT',
	UNSELECT_MINIMUM_COST_PER_SQUARE_FOOT = 'UNSELECT_MINIMUM_COST_PER_SQUARE_FOOT',
	// Minimum Cost Per Square Foot Version Actions
	LOAD_MINIMUM_COST_PER_SQUARE_FOOT_VERSIONS = 'LOAD_MINIMUM_COST_PER_SQUARE_FOOT_VERSIONS',
	SELECT_MINIMUM_COST_PER_SQUARE_FOOT_VERSION = 'SELECT_MINIMUM_COST_PER_SQUARE_FOOT_VERSION',
	UNSELECT_MINIMUM_COST_PER_SQUARE_FOOT_VERSION = 'UNSELECT_MINIMUM_COST_PER_SQUARE_FOOT_VERSION',
	// New Business Application Actions.
	LOAD_NEW_BUSINESS_APPLICATION = 'LOAD_NEW_BUSINESS_APPLICATION',
	LOAD_POSSIBLE_NEW_BUSINESS_DISCLOSURE_TEXTS = 'LOAD_NEW_BUSINESS_POSSIBLE_DISCLOSURE_TEXTS',
	LOAD_NEW_BUSINESS_BINDING_AUTHORITY_ELIGIBILITY_RESULTS = 'LOAD_NEW_BUSINESS_BINDING_AUTHORITY_ELIGIBILITY_RESULTS',
	LOAD_NEW_BUSINESS_APPLICATION_DOCUMENT = 'LOAD_NEW_BUSINESS_APPLICATION_DOCUMENT',
	LOAD_NEW_BUSINESS_POSSIBLE_PERILS = 'LOAD_NEW_BUSINESS_POSSIBLE_PERILS',
	// New Business Application Preliminary Actions.
	SAVE_NEW_BUSINESS_APPLICATION_PRELIMINARY_PERILS = 'SAVE_NEW_BUSINESS_APPLICATION_PRELIMINARY_PERILS',
	SAVE_NEW_BUSINESS_APPLICATION_PRELIMINARY_PROPERTY_ADDRESS = 'SAVE_NEW_BUSINESS_APPLICATION_PRELIMINARY_PROPERTY_ADDRESS',
	CLEAR_NEW_BUSINESS_APPLICATION_PRELIMINARY = 'CLEAR_NEW_BUSINESS_APPLICATION_PRELIMINARY',
	// New Business Building Actions.
	SELECT_NEW_BUSINESS_BUILDING = 'SELECT_NEW_BUSINESS_BUILDING',
	UNSELECT_NEW_BUSINESS_BUILDING = 'UNSELECT_NEW_BUSINESS_BUILDING',
	// New Business Mortgagee Actions.
	SELECT_NEW_BUSINESS_MORTGAGEE = 'SELECT_NEW_BUSINESS_MORTGAGEE',
	UNSELECT_NEW_BUSINESS_MORTGAGEE = 'UNSELECT_NEW_BUSINESS_MORTGAGEE',
	// Notification Actions.
	ADD_NOTIFICATION = 'ADD_NOTIFICATION',
	DELETE_NOTIFICATIONS = 'DELETE_NOTIFICATIONS',
	FLUSH_NOTIFICATIONS = 'FLUSH_NOTIFICATIONS',
	// Policy Actions
	LOAD_POLICY_COPY_ELIGIBLITY_STATUS = 'LOAD_POLICY_COPY_ELIGIBLITY_STATUS',
	// Policy Note Actions
	LOAD_POLICY_NOTES = 'LOAD_POLICY_NOTES',
	LOAD_POLICY_NOTE = 'LOAD_POLICY_NOTE',
	SELECT_POLICY_NOTE = 'SELECT_POLICY_NOTE',
	UNSELECT_POLICY_NOTE = 'UNSELECT_POLICY_NOTE',
	// Policy Note Email Actions.
	LOAD_POLICY_NOTE_EMAILS = 'LOAD_POLICY_NOTE_EMAILS',
	// Policy Term Year Actions.
	LOAD_POLICY_TERM_YEARS = 'LOAD_POLICY_TERM_YEARS',
	// Possible Building Use Actions.
	LOAD_POSSIBLE_BUILDING_USES = 'LOAD_POSSIBLE_BUILDING_USES',
	// Possible Construction Type Actions.
	LOAD_POSSIBLE_CONSTRUCTION_TYPES = 'LOAD_POSSIBLE_CONSTRUCTION_TYPES',
	// Possible Correspondence Recvd Or Sent Actions.
	LOAD_POSSIBLE_CORRESPONDENCE_RECVD_OR_SENT = 'LOAD_POSSIBLE_CORRESPONDENCE_RECVD_OR_SENT',
	// Possible Correspondence Subject Actions.
	LOAD_POSSIBLE_CORRESPONDENCE_SUBJECTS = 'LOAD_POSSIBLE_CORRESPONDENCE_SUBJECTS',
	// Possible Correspondence Type Actions.
	LOAD_POSSIBLE_CORRESPONDENCE_TYPES = 'LOAD_POSSIBLE_CORRESPONDENCE_TYPES',
	// Possible Correspondence Who Actions.
	LOAD_POSSIBLE_CORRESPONDENCE_WHO = 'LOAD_POSSIBLE_CORRESPONDENCE_WHO',
	// Possible Doc Category Actions.
	LOAD_POSSIBLE_DOC_CATEGORIES = 'LOAD_POSSIBLE_DOC_CATEGORIES',
	// Possible Foundation Type Actions.
	LOAD_POSSIBLE_FOUNDATION_TYPES = 'LOAD_POSSIBLE_FOUNDATION_TYPES',
	// Possible Occupancy Type Actions.
	LOAD_POSSIBLE_OCCUPANCY_TYPES = 'LOAD_POSSIBLE_OCCUPANCY_TYPES',
	// Possible Parking Type Actions.
	LOAD_POSSIBLE_PARKING_TYPES = 'LOAD_POSSIBLE_PARKING_TYPES',
	// Possible Peril Actions.
	LOAD_POSSIBLE_PERILS = 'LOAD_POSSIBLE_PERILS',
	// Possible Producer Agency Actions.
	LOAD_POSSIBLE_PRODUCER_AGENCIES = 'LOAD_POSSIBLE_PRODUCER_AGENCIES',
	// Possible Producer Agent Actions.
	LOAD_POSSIBLE_PRODUCER_AGENTS = 'LOAD_POSSIBLE_PRODUCER_AGENTS',
	// Processing Actions.
	START_PROCESSING = 'START_PROCESSING',
	END_PROCESSING = 'END_PROCESSING',
	// Producer Actions.
	LOAD_PRODUCER = 'LOAD_PRODUCER',
	// Producer Signup Actions.
	LOAD_POSSIBLE_HEARD_THROUGH_OPTIONS = 'LOAD_POSSIBLE_HEARD_THROUGH_OPTIONS',
	SET_NEW_PRODUCER = 'SET_NEW_PRODUCER',
	SET_PRODUCER_SIGNUP_STEP = 'SET_PRODUCER_SIGNUP_STEP',
	// Public Policy View Actions.
	LOAD_PUBLIC_POLICY_VIEW_DATA = 'LOAD_PUBLIC_POLICY_VIEW_DATA',
	LOAD_PUBLIC_POLICY_TERMS_WITH_STATUS = 'LOAD_PUBLIC_POLICY_TERMS_WITH_STATUS',
	UPDATE_PUBLIC_POLICY_MORTGAGEES = 'UPDATE_PUBLIC_POLICY_MORTGAGEES',
	CLEAR_PUBLIC_POLICY_VIEW_DATA = 'CLEAR_PUBLIC_POLICY_VIEW_DATA',
	// User Meta Data Actions.
	LOAD_USER_META_DATA = 'LOAD_USER_META_DATA',
	CLEAR_USER_META_DATA = 'CLEAR_USER_META_DATA',
	// Valid New Business Inception Date Boundaries Actions.
	LOAD_VALID_NEW_BUSINESS_INCEPTION_DATE_BOUNDARIES = 'LOAD_VALID_NEW_BUSINESS_INCEPTION_DATE_BOUNDARIES',
}

export default ActionType;